import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WalletLayoutComponent } from './wallet-layout/wallet-layout.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { WalletPaymentHandlingComponent } from './wallet-payment-handling/wallet-payment-handling.component';
import { RouterModule } from '@angular/router';
import { MatRippleModule } from '@angular/material/core';



@NgModule({
  declarations: [WalletLayoutComponent, WalletPaymentHandlingComponent],
  imports: [
    CommonModule,
    RouterModule,
    MatIconModule,
    MatRippleModule,
    MatButtonModule
  ]
})
export class PhlenuWalletModule { }
